import { render, staticRenderFns } from "./RelatedVideos.vue?vue&type=template&id=1dfa0c84&scoped=true&"
import script from "./RelatedVideos.vue?vue&type=script&lang=ts&"
export * from "./RelatedVideos.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedVideos.vue?vue&type=style&index=0&id=1dfa0c84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa0c84",
  null
  
)

export default component.exports